import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import UpdatePassForm from 'components/UpdatePassForm'
import Loading from 'components/Loading'
import { postUpdatePass } from 'services/RecoveryPassword'
import { useStorage64 } from 'hooks/useStorageBase64'
import { useHistory } from 'react-router-dom';
import { useIsMobile } from 'hooks/useIsMobile'

export default function UpdatePassword(props) {
    const {
        tokenUpdate,
        setUpdatePage
    } = props

    const location = window.location.origin

    const [successForm, getSuccessForm] = useState(false)
    const [dataForm, getDataForm] = useState(false)
    const [loading, setLoading] = useState(false)
    const [isLoged] = useStorage64('session_token', '')
    const { isMobile } = useIsMobile()
    const history = useHistory()

    const backHistory = () => {
        history.go(-1)
    }


    //- Funcion que manda el correo a solicitar su password
    useEffect(() => {
        if (dataForm) {
            postUpdatePass({ password: dataForm.password, token: tokenUpdate })
                .then(getSuccessForm)
        }
    }, [dataForm])

    //- Remueve el modal una ves responde el servicio

    useEffect(() => {
        if (successForm) {
            setLoading(false)
            // console.log(successForm)
        }
    }, [successForm])

    // recibe los datos del formulario
    const reciveData = (val) => {
        getDataForm(val)
        setLoading(true)
    }
    const refreshPage = () => {
        setUpdatePage(true)
    }

    return (
        <>
            { loading && <Loading />}
            
            {successForm
                ?
                    successForm.statusCode === 200
                        ?
                            <>
                                {isMobile === 'desktop'
                                    ?
                                        <h1 className="titleRegistro">Generar nueva contraseña</h1>
                                    :
                                        <div className="sectionTitleServicioCliente">
                                            <button onClick={backHistory}>Generar nueva contraseña</button>
                                        </div>
                                }
                                <div className="loginPage">
                                    <p className="textResponseMessagePass">Tu contraseña se genero exitosamente.</p>
                                    {isLoged
                                        ?
                                            <Link to={`/`} className="btn rojo">Ir al home</Link>
                                        :
                                            <Link to={`/login?redirect=${location}/`} className="btn rojo">Ir al login</Link>
                                    }
                                </div>
                            </>
                        :
                            <>
                                <img src="img/reloj.png" width="200" height="200" className="icoOpps" alt="¡¡Oooops!!"/>
                                <h1 className="h1oops">¡¡Oooops!!</h1>
                                <div className="loginPage">
                                    <p className="textResponseMessagePass">El link para recuperar la contraseña a caducado o ya ha sido utilizado. <span className="text2">Te recomendamos volver hacer el proceso.</span></p>
                                    <Link to="/recuperar-contrasena/" className="btn rojo" onClick={refreshPage}>Regresar a recuperar contraseña</Link>
                                </div>
                            </>
                            
                :
                    <>
                        {isMobile === 'desktop'
                            ?
                                <h1 className="titleRegistro">Generar nueva contraseña</h1>
                            :
                                <div className="sectionTitleServicioCliente">
                                    <button onClick={backHistory}>Generar nueva contraseña</button>
                                </div>
                        }
                        <p className="smallText">Ingresa una contraseña segura</p>
                        <UpdatePassForm
                            dataForm={reciveData}
                        />
                    </>
            }
        </>
    )
}